// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__2UBF5","title":"Header_title__2ZLKp","left":"Header_left__3WX4D","clinicName":"Header_clinicName__3i71k"};